import { Component, OnInit, Input } from '@angular/core';
import { SetService, HttpService } from 'ngx-block-core';
import { FormControlService } from "ngx-block-core";
import { selectDriverType, selectDriverOrientation, iconTheme } from "../../../data/data";

@Component({
  selector: 'sucu06-element0030001',
  templateUrl: './sucu06-element0030001.component.html',
  styleUrls: ['./sucu06-element0030001.component.css']
})
export class Sucu06Element0030001Component implements OnInit {

  @Input() local = false;
  @Input() static = false;
  @Input() blockid = "-1";
  @Input() layoutid = "-1";
  @Input() nzFormGroupData;
  @Input() nzLayout = 'horizontal'

  value
  @Input() sets = {
    blockCode: "sucublock35",
    blockId: "",
    layoutId: "",
    blockType: 'element',
    blockChildType: '',
    versionCode: 2,
    styles: {
      nzTitle: "我是分割线，我可以斩断一切",
      nzType: "horizontal",
      nzOrientation: "",
      nzDashed: false,
      nzIconSize: "16",
      nzIconType: "",
      nzIconTheme: "",
      nzIconColor: "",
      nzIconSpin: false

    },
    datas: {
      nzDynamicValue: {
        nzUsed: false,
        nzDynamicSql: ""

      }

    }
  };

  setData = []

  constructor(
    public setService: SetService,
    private formControlService: FormControlService,
    private http: HttpService,

  ) { }
  ngOnInit() {

    this.baseInit();
    this.getControl();
    this.autoUpdate();
  }
  autoUpdate() {

    //v3,升级自定义表单参数
    if (this.sets.versionCode < 2) {

      this.sets.blockCode = "sucublock35";

      this.sets.versionCode = 2;
    }

  }

  setDataInit() {
    this.setData = [
      {
        tabName: '数据',
        datas: [
          {
            type: 'datas',
            data: [
              {
                name: 'nzDefault',
                outputs: {
                  ngModelChange: (event) => {
                    this.setService.setDatas[this.blockid][0]['datas'][0]['data'][1]['show'] = event;
                  }
                }
              },
              {
                name: 'button',
                show: this.sets.datas.nzDynamicValue.nzUsed,
                inputs: { nzText: ['刷新'], nzLayout: [0, 24], nzAligns: ['center'] },
                outputs: {
                  onClick1: () => {
                    this.setService.onReLoadbBlock(this.layoutid)

                  }
                }
              },
            ]
          }


        ]
      },
      {
        tabName: '样式',
        datas: [

          {
            type: 'styles',
            data: [

              {
                name: 'radio',
                inputs: { nzText: "类型 : ", nzKeys: ['styles', 'nzType'], nzData: selectDriverType }
              },
              {
                name: 'switch',
                inputs: { nzText: "是否虚线 : ", nzKeys: ['styles', 'nzDashed'] }
              },
              {
                name: 'radio',
                inputs: { nzText: "文字方向 : ", nzKeys: ['styles', 'nzOrientation'], nzData: selectDriverOrientation }
              },
              {
                name: 'number',
                inputs: { nzText: "图标尺寸:", nzKeys: ['styles', 'nzIconSize'], nzFormat: ' px' }
              },
              {
                name: 'select',
                inputs: { nzText: "图标主题:", nzKeys: ['styles', 'nzIconTheme'], nzData: iconTheme },
                outputs: {
                  ngModelChange: (event) => {


                    if (event == 'twotone') {

                      this.setService.setDatas[this.blockid][0]['datas'][0]['data'][6]['show'] = true;

                    } else {
                      this.setService.setDatas[this.blockid][0]['datas'][0]['data'][6]['show'] = false;

                    }

                    this.setService.onReLoadbBlock(this.layoutid);

                  }
                }
              },
              {
                name: 'input',
                inputs: { nzText: "图标类型:", nzKeys: ['styles', 'nzIconType'] },
                outputs: { ngModelChange: () => { if (this.sets.styles.nzIconType == '') this.setService.onReLoadbBlock(this.layoutid) } }
              },
              {
                name: 'color',
                show: this.sets.styles.nzIconType == 'twotone',
                inputs: { nzText: "图标颜色:", nzKeys: ['styles', 'nzIconColor'] }
              },
              {
                name: 'switch',
                inputs: { nzText: "动画:", nzKeys: ['styles', 'nzIconSpin'], nzPopContent: ['图标动画'] }
              },

            ]
          },

        ]
      },

    ]
  }
  baseInit() {

    if (!this.local) {//非本地
      if (!this.static) {//非静态
        if (this.setService.blocksort[this.blockid]['sets'] !== "{}") {
          this.sets = this.setService.blocksort[this.blockid]['sets'];
        } else {
          this.setService.blocksort[this.blockid]['sets'] = this.sets;
        }
        console.log("sets", this.sets, this.blockid)

        this.sets.blockId = this.blockid;
        this.sets.layoutId = this.layoutid;


        this.setDataInit();
        if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
          this.setService.setDatas[this.blockid] = this.setData;
        }
        

      }
      else {//静态
        if(typeof this.sets=="string")
        this.sets = JSON.parse(<any>this.sets);
        this.blockid = this.sets.blockId;
        this.layoutid = this.sets.layoutId;
      }
    }
  }

  getControl() {

    if (this.sets.datas.nzDynamicValue.nzUsed) {
      let body = {
        // 
        // "dynamicSql": 'select test001_name as value from t_test001 where test001_id=16',
        "dynamicSql": this.sets.datas.nzDynamicValue.nzDynamicSql,
        "pageSize": 0,
        "nowPage": 0,
        "paramMap": [],
        "tableSort": [],
        "searchMap": {
        }
      }
      this.http.postHttp("/system/dynamicSql", body).subscribe(
        (data: any) => {
          console.log("dynamicSql:" + JSON.stringify(data));
          this.sets.styles.nzTitle = data.data.list[0]['value'];

        }, (error: any) => {

          this.sets.styles.nzTitle = "sql错误";

        })
    }

  }

}
